import { React, useState, useEffect } from 'react';
import "./index.css";
import { useNavigate } from 'react-router-dom';
import { USER_API } from '../../functions';
import axios from 'axios';
import { DashboardCard, SideBarGPT } from '../../Components';
import Cookies from 'js-cookie';
import Swal from 'sweetalert2';
import lottie from 'lottie-web';
import { useRef } from 'react';

const UserInfo = () => {

    const navigate = useNavigate();
    const [user, setUser] = useState();
    const [fathername, setFathername] = useState();
    const [city, setCity] = useState();
    const [classs, setClasss] = useState();
    const [TestFound, setTestFound] = useState([]);
    const [ifLoading, setIfLoading] = useState(true);

    // let famousQuote = "Consistency and hard work pave the path to achievement, making dreams a reality.";


    const setLoadedData = async () => {
        // console.log("unmounting");
        UserID = localStorage.getItem("user")
        UserID = JSON.parse(UserID);
        if (UserID === null) {
            navigate("/");
        }
        else {
            try {
                let res = await axios.get(`${USER_API}/getData/${UserID}`);
                const data = res.data;
                if (data.ifAdmin) {
                    navigate("/Admin")
                }
                // console.log(data);
                setUser(data.Name);
                setFathername(data.FatherName);
                setCity(data.City);
                // console.log(data.Class)
                setClasss(data.Class);
                setTestDetails(data.TestHistory);
                const AllTest = await axios.get(`${USER_API}/getTest/${data.Class}`);
                // console.log(AllTest.data.test);
                const test = AllTest.data.test;
                setTestFound(test);
            }
            catch (err) {
                Swal.fire({
                    title: 'Error !!',
                    text: 'Something went wrong. Please try again later.',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })
            }
        }
        setIfLoading(false);
    }


    const checkuser = async () => {
        const user = Cookies.get("user");
        if (user === undefined) {
            navigate("/login");
        }
        else {
            try {
                const res = await axios.get(`${USER_API}/getData/${user}`);
                const data = res.data;
                if (data) {
                    setLoadedData();
                }
                else {
                    navigate("/login");
                }
            }
            catch (err) {
                Swal.fire({
                    title: 'Error !!',
                    text: 'Something went wrong. Please try again later.',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                }).then(() => {
                    navigate("/login");
                })

            }
        }

        if (localStorage.getItem("timeOut")) {
            Swal.fire({
                title: 'Warning !!',
                text: 'You have been suspected of leaving test in between. Please contact your teacher.',
                icon: 'warning',
                confirmButtonText: 'Ok'
            }).then(() => {
                localStorage.removeItem("timeOut");
                localStorage.removeItem("testId");
                localStorage.removeItem("test");
            })

        }
    }

    useEffect(() => {
        checkuser();
    }, [])




    let UserID = localStorage.getItem("user");
    UserID = JSON.parse(UserID);


    const initialTest = [
        {
            id: 1,
            test: '-- -- ---',
            score: "--/--",
            date: "DD/MM/YYYY",
        }
    ]
    const [testDetails, setTestDetails] = useState(initialTest);




    const MyProfile = () => {
        return (
            <div className='w-[100%] p-3 mt-[4vh] mx-[5vw]'>
                <h1 className='my-[6vh]  font-semibold'>Student DashBoard</h1>
                <div className=' m-3 flex flex-col space-y-6 flex  align-middle flex-col'>
                    <div className=' sm:text-base md:text-xl'>
                        <p className='font-semibold'><span className='font-normal text-gray-600'>STUDENT NAME </span> - {user}</p>
                    </div>
                    <div className='sm:text-base md:text-xl'>
                        <p className='font-semibold'><span className='font-normal text-gray-600'>STUDENT FATHER'S NAME </span> - {fathername}</p>
                    </div>
                    <div className='sm:text-base md:text-xl'>
                        <p className='font-semibold'><span className='font-normal text-gray-600'>STUDENT'S CLASS </span> - {classs}</p>
                    </div>
                    <div className='sm:text-base md:text-xl'>
                        <p className='font-semibold'><span className='font-normal text-gray-600'>STUDENT'S CITY </span> - {city}</p>
                    </div>
                </div>
                <div className='flex align-middle flex-wrap'>
                    <DashboardCard CTA="Attempted Tests" value={testDetails.length} Comp="Book" />
                    <DashboardCard CTA="Tests Available" value={TestFound.length} Comp="History" />
                </div>
            </div>
        )
    }

    const ref = useRef(null);
    const Loader = () => {
        useEffect(() => {
            const Animator = lottie.loadAnimation({
                container: ref.current,
                animationData: require('../../Components/Animations/GeneralLoading.json'),
                renderer: 'svg',
                loop: true,
                autoplay: true,
            });

            return () => Animator.destroy();
        }, [])

        return (
            <div className='flex justify-center items-center h-screen w-[min(100vw,50rem)] flex-col'>
                <div ref={ref} className='w-[min(100vw,50rem)]'> </div>
                <p>Loading Assets</p>
            </div>
        );

    }



    return (
        <div className='p-[2vw]'>
            <div className='MQSidebar'>
                <SideBarGPT />
                {ifLoading ? <Loader /> : (
                    <MyProfile />
                )}
            </div>
        </div>
    )
}

export default UserInfo